import './App.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

import { useEffect } from 'react';
import MainRoutes from 'routes/MainRoutes';
import { useLocation } from 'react-router-dom';
import { HeadUpdater } from 'hooks/HeadUpdater';
import AllProviders from 'providers/AllProviders';
import { useAxiosWithToast } from 'hooks/axiosInterceptor';
import { useGetOrganizations } from 'apis/agency/organizations/hook';

function App() {
  const { ToastComponent } = useAxiosWithToast();

  return (
    <AllProviders>
      <OrganizationHeadUpdater />
      <ScrollToTop />
      <MainRoutes />
      <ToastComponent />
    </AllProviders>
  );
}

export default App;

export const ScrollToTop = ({ state }: { state?: number | null }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, state]);
  return null;
};

export const OrganizationHeadUpdater = () => {
  const { data: organization } = useGetOrganizations();
  return (
    <HeadUpdater title={organization?.name} faviconUrl={organization?.favicon_url} description={organization?.name} />
  );
};
